import { readFile } from "../../../utilities/readFile";
import * as XLSX from "xlsx";
import { useCallback, useState } from "react";
import async from "async";
import { ProgressBar } from "react-bootstrap";
import useAxios from "../../../services/useAxios";
import useWindowSize from "../../../hooks/useWindowSize";

export default function AvbUpload() {
  let regNumber = /^\d+$/;
  let { width, height } = useWindowSize();
  const [excelData, setExcelData] = useState({
    errorList: [],
    completeCount: 0,
    totalCount: 0,
  });
  const translate = {
    supplier_id: 1,
    product_id: 2,
    price: 3,
    inventory: 5,
    discount: 4,
  };
  const { execute: uploadExcel } = useAxios("superadminapi/upload_avbproduct");
  const errorReason = (status) => {
    let reason = "";
    switch (status) {
      case -100:
        reason = "نوع یا الزامی بودن ستونهای اکسل رعایت نشده است.";
        break;
      case -2:
        reason = "مشکلی در ثبت عکس پیش آمده است.";
        break;
      case -3:
        reason = "مشکلی در ثبت پیش آمده است.";
        break;
    }
    return reason;
  };
  const dataHandler = (object) => {
    setExcelData((prev) => {
      return { ...prev, ...object };
    });
  };
  const errorHandler = (object) => {
    setExcelData((prev) => {
      return { ...prev, errorList: [...prev.errorList, object] };
    });
  };
  const AddOne = () => {
    setExcelData((prev) => {
      return { ...prev, completeCount: prev.completeCount + 1 };
    });
  };
  const resetData = () => {
    setExcelData({
      errorList: [],
      completeCount: 0,
      totalCount: 0,
    });
  };
  const finalQueue = async.queue((task, callback) => {
    uploadExcel(task).then((res) => {
      if (res.status == 1) {
        AddOne();
        callback();
      } else {
        errorHandler({ ...task, status: res.status });
        callback();
      }
    });
  }, 10);

  const requestFunc = useCallback(
    (data) => {
      dataHandler({ totalCount: data.length });
      let temp = data.map((value, index) => {
        return {
          supplier_id: value[1],
          product_id: value[2],
          price: value[3],
          inventory: value[5],
          discount: value[3] - value[4],
        };
      });
      finalQueue.push(temp);
      console.log(temp);
      // console.log(data.filter((val) => console.log(val[2])));
    },
    [finalQueue]
  );
  const FileHandler = useCallback(
    async (e) => {
      resetData();
      let files = e.target.files;

      for (let i = 0; i < files.length; i++) {
        let file = await readFile(files);
        let data = XLSX.read(file, {
          type: "binary",
          raw: true,
        });
        for (let sheetName of data.SheetNames) {
          let res = XLSX.utils.sheet_to_json(data.Sheets[sheetName], {
            header: 1,
          });
          let x = res.filter((val, ind) => {
            if (
              ind != 0 &&
              regNumber.test(val[1]) &&
              regNumber.test(val[2]) &&
              regNumber.test(val[3]) &&
              regNumber.test(val[4]) &&
              regNumber.test(val[5])
            )
              return val;
            else if (ind != 0)
              errorHandler({
                supplier_id: val[1] ?? 0,
                product_id: val[2] != undefined ? val[2] : "",
                price: val[3] != undefined ? val[3] : "0",
                discount: val[4] != undefined ? val[4] : "0",
                inventory: val[5] != undefined ? val[5] : "0",
                status: -100,
              });
          });
          console.log(x);
          requestFunc(x);
        }
      }
    },
    [requestFunc]
  );
  return (
    <div>
      <p className="title-h3-m mt-3 text-center">آپلود محصولات فروشگاه</p>
      <div
        className="text-center mb-4 mt-3 border rounded  py-4  mx-auto border-success shadow d-flex flex-column "
        style={{
          width: width > 800 ? "50%" : "90%",
          padding: width > 800 ? "0 20px" : "0 10px",
        }}
      >
        <p className="my-2 txt-t3-m">لطفا فایل مورد نظر را آپلود کنید.</p>
        <input
          className="mx-auto border rounded mb-3"
          type="file"
          style={{ overflow: "hidden" }}
          onChange={(e) => {
            FileHandler(e);
          }}
        />
        <ProgressBar
          className="mb-2"
          now={excelData.completeCount}
          max={excelData.totalCount}
          variant="success"
        />
        {excelData.totalCount}/{excelData.completeCount}
      </div>
      <div className="ms-3 txt-t2-m">
        {" "}
        <ul>
          {excelData.errorList.map((value) => {
            return (
              <li>
                فروشگاه {value.supplier_id}, محصول {value.product_id}&nbsp;{" "}
                {"=>"} &nbsp;
                <span className="text-danger">{errorReason(value.status)}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
